import { useState } from "react";
import CadModel from "./CadModel";
import EngineerDrawing from "./EngineerDrawing";
import { useFetchPart } from "@/lib/queries/hooks";

export default function FileDisplay() {
  const [showCadModel, setShowCadModel] = useState(false);

  const { data: part } = useFetchPart();
  const parentPartTD = part?.parent_technical_drawing; // will be null if this part has its own drawing
  const tdUrl = part?.technical_drawing?.url ?? parentPartTD?.url;
  const cadModelUrl = part?.cad_model?.embed_url;

  if (!tdUrl && cadModelUrl) {
    return <CadModel show={true} url={cadModelUrl} />;
  } else if (tdUrl && !cadModelUrl) {
    return (
      <EngineerDrawing show={true} url={tdUrl} parentPartTD={parentPartTD} />
    );
  }

  return (
    <>
      <EngineerDrawing
        hide={cadModelUrl ? () => setShowCadModel(true) : undefined}
        show={!showCadModel}
        url={tdUrl}
        parentPartTD={parentPartTD}
        thumbnailUrl={part?.thumbnail_url}
      />
      <CadModel
        hide={() => setShowCadModel(false)}
        show={showCadModel}
        url={cadModelUrl}
      />
    </>
  );
}
